import { Link } from "react-router-dom";
import axios from "@/shared/config/axios-interceptor";
import {
  ITransaction,
  typeTransaction,
} from "@/shared/model/transaction.model";
import { RootState } from "@/reducers";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { format } from "path";
import { formatMoney } from "@/shared/utils/ultils";

export enum statusTransaction {
  pendding = 0, // Đang chờ
  success = 1, // Thành công
  error = 2, // Thất bại
}

const HistoryWithdraw = () => {
  const { user } = useSelector((state: RootState) => state.authentication);
  const [listData, setListData] = useState<ITransaction[]>([]);
  const getData = async () => {
    if (!user?.id) return;
    try {
      const res = await axios.get(
        `/transaction?type=${typeTransaction.withdraw}&limit=60&sortOrder=DESC&sortBy=id&userId=${user?.id}`
      );
      setListData(res?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, [user]);

  const renderStatus = (status: number) => {
    switch (status) {
      case statusTransaction.success:
        return (
          <span className="align-content-center badge bg-success">
            Thành công
          </span>
        );
      case statusTransaction.error:
        return (
          <span className="align-content-center badge bg-danger">Thất bại</span>
        );
      default:
        return (
          <span className="align-content-center badge bg-secondary">
            Đang chờ
          </span>
        );
    }
  };
  return (
    <div className="wrapper">
      <div className="container-web bg2 bank">
        <div
          className="d-flex align-items-center justify-content-between px-3"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 999,
            background: "#0262b0",
            height: 50,
            maxWidth: 500,
            margin: "auto",
            color: "#fff",
          }}
        >
          <Link to="/account">
            <i
              style={{ color: "#fff" }}
              className="fa-solid fa-chevron-left"
            ></i>
          </Link>
          <div>LỊCH SỬ RÚT TIỀN</div>
          <div></div>
        </div>
        <div style={{ paddingTop: 50 }}></div>

        <div className="p-3">
          {listData?.length === 0 && <h6>Chưa có lịch sử</h6>}
          {listData?.map((item, index) => {
            return (
              <div
                className="p-3 mb-3 rounded-3"
                style={{
                  fontSize: 13,
                  background: "rgba(255, 255, 255, 0.24)",
                }}
                key={index}
              >
                <div className="d-flex align-items-center justify-content-between">
                  <span>
                    {dayjs(item?.createdDate).format("DD/MM/YYYY HH:mm:ss")}
                  </span>
                  {renderStatus(item?.status)}
                </div>

                <div>
                  <span className="d-block mt-1">
                    Số tiền rút: {formatMoney(item?.money)}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HistoryWithdraw;
